module.exports = __webpack_public_path__ + "static/media/earnedFitness.43bacb45.jpeg";